import { create } from 'zustand';

interface AccountErrorsState {
	isBannerVisible: boolean;
	showBanner: () => void;
	hideBanner: () => void;
	toggleBanner: () => void;
}

export const useAccountErrorsStore = create<AccountErrorsState>((set) => ({
	isBannerVisible: false,
	showBanner: () => set({ isBannerVisible: true }),
	hideBanner: () => set({ isBannerVisible: false }),
	toggleBanner: () => set((state) => ({ isBannerVisible: !state.isBannerVisible })),
}));
